module.exports = __webpack_public_path__ + "img/xroad_logo_64.bed4a00e.png";